import React from 'react';
import {navigate} from 'gatsby';

//CORE COMPONENTS
import { ThemeProvider, styled } from '../../../../components-core/packages/components-core/dist/theme-provider/index';
import { Container, } from '../../../../components-core/packages/components-core/dist/container/index';
import { Layout } from '../../../../components-core/packages/components-core/dist/layout/index';
import { IntegratorRoot } from '../../../../components-core/packages/components-core/dist/integrator-root/index';
import { Button } from '../../../../components-core/packages/components-core/dist/button/index';
import { Breakpoints } from '../../../../components-core/packages/components-core/dist/helpers';


const TopContainer = styled.div`
    width: 100vw;
`;

const LineContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;

    padding-right: ${props => props.position === 'left' ? '8px' : 0};
    padding-left: ${props => props.position === 'right' ? '8px' : 0};
`;

const LineMiddleContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
`;

const Line = styled.hr`
    width: 100%;
    height: 2px;
    margin: 0;
`;

const LineWithOutButton = styled.hr`
    width: 80%;
    height: 2px;
    margin-left:150px

`;

class LineLane extends React.Component {

    render() {
        if(this.props.custom10 == 1){
            return(
                <IntegratorRoot>
                <ThemeProvider>
                    <TopContainer>
                            <LineWithOutButton/>
                    </TopContainer><br/><br/>
                </ThemeProvider>
            </IntegratorRoot>
            )
        }else {
            return(
                <IntegratorRoot>
                <ThemeProvider>
                    <TopContainer>
                        <Layout appearance={buttonLaneLayoutAppearance}>
                            {renderLine('left')}
                            <Button 
                                onClick={() => window.open(this.props.custom9, '_blank')} 
                                stretchContent={true}
                            >
                                Teknik broşürü incele
                            </Button>
                            {renderLine('right')}
                        </Layout>
                    </TopContainer><br/><br/>
                </ThemeProvider>
            </IntegratorRoot>
            )
        }
    }
}

const renderMiddLine =()=> {
    <LineMiddleContainer>
        <Line/>
    </LineMiddleContainer>
}

const renderLine = (position) => (
    <LineContainer position={position}>
        <Line />
    </LineContainer>
)

const buttonLaneLayoutAppearance = {
    [Breakpoints.default]: [
        { name: '.', columns: 2 },
        { name: 'a', columns: 4 },
        { name: 'b', columns: 12 },
        { name: 'c', columns: 4 },
        { name: '.', columns: 2 }
    ],
    [Breakpoints.b560]: [
        { name: '.', columns: 2 },
        { name: 'a', columns: 6 },
        { name: 'b', columns: 8 },
        { name: 'c', columns: 6 },
        { name: '.', columns: 2 }
    ],
    [Breakpoints.b960]: [
        { name: '.', columns: 2 },
        { name: 'a', columns: 7 },
        { name: 'b', columns: 6 },
        { name: 'c', columns: 7 },
        { name: '.', columns: 2 }
    ],
    [Breakpoints.b1280]: [
        { name: '.', columns: 2 },
        { name: 'a', columns: 8 },
        { name: 'b', columns: 4 },
        { name: 'c', columns: 8 },
        { name: '.', columns: 2 }
    ]
}

export default LineLane;